import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import type { ResourceSection as ResourceSectionType } from "./types";

interface ButtonSectionProps {
  section: ResourceSectionType;
}

export const ButtonSection = ({
  section: { icon, title, description, iconAlt, button },
}: ButtonSectionProps) => (
  <div className="flex flex-row items-start gap-x-4 sm:items-center">
    <div>
      <img src={icon} loading="lazy" alt={iconAlt} className="size-10" />
    </div>
    <div className="flex w-full flex-col items-start justify-between gap-y-2 sm:flex-row sm:items-center sm:gap-y-0">
      <div>
        <Typography.TitleSm
          weight="semibold"
          size="text-sm"
          leading="leading-5"
          color="text-dark"
        >
          {title}
        </Typography.TitleSm>
        <Typography.BodySm weight="normal" size="text-sm" color="text-default">
          {description}
        </Typography.BodySm>
      </div>
      <div>
        {button && (
          <Button variant="secondary" small onClick={button.handleClick}>
            {button.label}
          </Button>
        )}
      </div>
    </div>
  </div>
);
